module.exports = __webpack_public_path__ + "img/item1.6dc6ce3b.png";